import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'icon-added',
    templateUrl: './icon-added.component.html',
    styleUrls: ['./icon-added.component.scss'],
    standalone: false
})
export class IconAddedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
